class IconConstants {
  static ACTIONABLE_ICON_SIZE = 40;

  static VERY_FAINT_GREY = '#FAFAFA';

  static FAINT_GREY = '#EFEFEF';

  static INACTIVE_DARKISH_GREY = '#B0AFAF';

  static GREY = '#757474';

  static DARK_GREY = '#4D4C4C';

  static WHITE = '#FFFFFF';

  static ACTIVE_LIGHT_BLUE = '#F2FAFA';

  static DARK_BLUE = '#005B67';

  static DARKER_BLUE = '#3F6692';

  static YELLOW = '#E3D300';

  static GREEN = '#008500';
}

export default IconConstants;
